module.exports = __webpack_public_path__ + "media/newstyle/images/card-ee5212176119b5f2dcf8141b27a74050.svg";